var _style, _defs, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinances(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 28",
    style: {
      enableBackground: "new 0 0 30 28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 2.2,
    y: 1.4,
    width: 26,
    height: 24.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.6,25.3V14.8c0,0,0,0,0,0h-3.9c0,0,0,0,0,0v10.6c0,0,0,0,0,0L27.6,25.3C27.6,25.4,27.6,25.4,27.6,25.3  M28.3,14.8v10.6c0,0.4-0.3,0.7-0.7,0.7h-3.9c-0.4,0-0.7-0.3-0.7-0.7V14.8c0-0.4,0.3-0.7,0.7-0.7h3.9 C27.9,14.1,28.3,14.4,28.3,14.8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.5,9.1c0-0.8-0.7-1.5-1.5-1.5c-0.9,0-1.5,0.7-1.5,1.5c0,0.8,0.7,1.5,1.5,1.5C5.8,10.6,6.5,9.9,6.5,9.1  M13.4,3.6c0-0.8-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5S13.4,4.5,13.4,3.6 M20.3,11c0-0.8-0.7-1.5-1.5-1.5 c-0.9,0-1.5,0.7-1.5,1.5c0,0.8,0.7,1.5,1.5,1.5C19.6,12.5,20.3,11.9,20.3,11 M27.1,7.7c0-0.8-0.7-1.5-1.5-1.5 c-0.9,0-1.5,0.7-1.5,1.5c0,0.8,0.7,1.5,1.5,1.5C26.5,9.3,27.1,8.6,27.1,7.7 M25.6,5.6c1.2,0,2.2,1,2.2,2.2c0,1.2-1,2.2-2.2,2.2 c-0.8,0-1.4-0.4-1.8-0.9l-2.9,1.4c0.1,0.2,0.1,0.4,0.1,0.6c0,1.2-1,2.2-2.2,2.2c-1.2,0-2.2-1-2.2-2.2c0-0.5,0.2-1,0.5-1.4l-3.9-4.2 c-0.4,0.2-0.8,0.4-1.2,0.4c-0.6,0-1.1-0.2-1.5-0.6L6.9,8c0.2,0.3,0.3,0.7,0.3,1.1c0,1.2-1,2.2-2.2,2.2c-1.2,0-2.2-1-2.2-2.2 c0-1.2,1-2.2,2.2-2.2c0.6,0,1.1,0.2,1.5,0.6l3.4-2.7C9.7,4.4,9.6,4,9.6,3.6c0-1.2,1-2.2,2.2-2.2s2.2,1,2.2,2.2c0,0.5-0.2,1-0.5,1.4 l3.9,4.2c0.4-0.2,0.8-0.4,1.2-0.4c0.8,0,1.4,0.4,1.8,0.9l2.9-1.4c-0.1-0.2-0.1-0.4-0.1-0.6C23.4,6.5,24.4,5.6,25.6,5.6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.7,25.3v-7.2c0,0,0,0,0,0h-3.9c0,0,0,0,0,0v7.2c0,0,0,0,0,0L20.7,25.3C20.7,25.4,20.7,25.4,20.7,25.3  M21.4,18.1v7.2c0,0.4-0.3,0.7-0.7,0.7h-3.9c-0.4,0-0.7-0.3-0.7-0.7v-7.2c0-0.4,0.3-0.7,0.7-0.7h3.9C21.1,17.4,21.4,17.7,21.4,18.1 "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.8,25.3V10.7c0,0,0,0,0,0H9.9c0,0,0,0,0,0v14.7c0,0,0,0,0,0L13.8,25.3C13.8,25.4,13.8,25.4,13.8,25.3  M14.5,10.7v14.7c0,0.4-0.3,0.7-0.7,0.7H9.9c-0.4,0-0.7-0.3-0.7-0.7V10.7c0-0.4,0.3-0.7,0.7-0.7h3.9C14.2,9.9,14.5,10.3,14.5,10.7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.9,25.3v-9.2c0,0,0,0,0,0H3c0,0,0,0,0,0v9.2c0,0,0,0,0,0L6.9,25.3C6.9,25.4,6.9,25.4,6.9,25.3 M7.6,16.1v9.2 c0,0.4-0.3,0.7-0.7,0.7H3c-0.4,0-0.7-0.3-0.7-0.7v-9.2c0-0.4,0.3-0.7,0.7-0.7h3.9C7.3,15.4,7.6,15.7,7.6,16.1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinances);
export default __webpack_public_path__ + "static/media/finances.7fb7f900.svg";
export { ForwardRef as ReactComponent };